import { useEffect, useRef, useState } from 'react';
import styles from './ReviewHotpleModal2.module.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import ko from "date-fns/locale/ko";
import DetailHeader from '../DetailHeader/DetailHeader';
import { openInstagramMedia } from '../../../../../util';


const ReviewHotpleModal2 = ({setHotpleModalPage, editedHotple, updateHotpleField, originalHotple, updateHotpleInfo, account, marginTop, isEditRequest=false}) => {
      const [startDate, setStartDate] = useState(null);
      const [endDate, setEndDate] = useState(null);
      const [beforeInfo, setBeforeInfo] = useState(null);
      const datePickerRef1 = useRef(null); // 첫 번째 DatePicker용 ref
      const datePickerRef2 = useRef(null); // 두 번째 DatePicker용 ref

      const handleCancelButtonClick = () => {
            updateHotpleField("start_date", beforeInfo.start_date);
            updateHotpleField("end_date", beforeInfo.end_date);
            updateHotpleField("has_period", beforeInfo.has_period);
            if(isEditRequest)
                  setHotpleModalPage(21);
            else
                  setHotpleModalPage(11);
      };

      const handleEditButtonClick = () => {
            /*if(editedHotple.caption==''||editedHotple.tags[0]==''||editedHotple.tags[1]==''||editedHotple.tags[2]=='')
                  return;
            */
            if(isEditRequest)
                  setHotpleModalPage(21);
            else
                  setHotpleModalPage(11);
      };

      const clearDate1 = () => {
            datePickerRef1.current.setOpen(false); // 첫 번째 DatePicker 팝업 닫기
            datePickerRef1.current.clear(); // 첫 번째 DatePicker 날짜 초기화
      };
      
      const clearDate2 = () => {
            datePickerRef2.current.setOpen(false); // 두 번째 DatePicker 팝업 닫기
            datePickerRef2.current.clear(); // 두 번째 DatePicker 날짜 초기화
      };

      const handleNextButtonClick = async () => {
            /*if(editedHotple.caption==''||editedHotple.tags[0]==''||editedHotple.tags[1]==''||editedHotple.tags[2]=='')
                  return;
            */

            setHotpleModalPage(3)
      };
      
      useEffect(() => {
            updateHotpleField("start_date",startDate ? format(startDate, 'yyyy-MM-dd HH:mm'):null);
            updateHotpleField("has_period", startDate!=null || endDate!=null);
      },[startDate]);
      useEffect(() => {
            updateHotpleField("end_date",endDate ? format(endDate, 'yyyy-MM-dd HH:mm'):null);
            updateHotpleField("has_period", startDate!=null || endDate!=null);
      },[endDate]);


      useEffect(() => {
            if(!originalHotple.need_verify)
                  setBeforeInfo(editedHotple);

            setTimeout(() => {
                  if(editedHotple){
                        if(editedHotple.start_date)
                              setStartDate(new Date(editedHotple.start_date.replace(' ', 'T')));
                        if(editedHotple.end_date)
                              setEndDate(new Date(editedHotple.end_date.replace(' ', 'T')));
                  }
            }, 100);
      }, []);

      return (
            <div className={styles.reviewmodal2} style={{maxHeight: `calc(100dvh - ${marginTop + 24}px)`, marginTop: `${marginTop}px`}}>
            <div className={styles.loginframe}>
                  <div className={styles.headerframe}>
                        
                        {originalHotple.need_verify ?
                              <b className={styles.b}>혹시 특정 기간만<br/>진행되는 핫플인가요?</b>
                        :
                              <b className={styles.b}>어떻게 수정할까요?</b>
                        }
                        <div className={styles.instagrambutton} onClick={()=>openInstagramMedia(originalHotple.media_url)}>
                              게시글 확인하고 오기 →
                        </div>

                        {account.isAdmin &&
                              <DetailHeader hotple={editedHotple} updateHotpleField={updateHotpleField} updateHotpleInfo={updateHotpleInfo}/>
                        }
                        {originalHotple.media_caption &&
                              <div className={styles.captionFrame}>
                                    <div className={styles.mediaCaption1}>게시글 본문</div>
                                    <div className={styles.mediaCaption} style={{ whiteSpace: 'pre-line', lineHeight: '1.1' }}>{originalHotple.media_caption.replace(/\n{3,}/g, '\n\n')}</div>
                              </div>
                        }
                  </div>
                  <div className={styles.contentsframe}>
                        <div className={styles.bottomframe}>
                              <div className={styles.textFrame}>
                                    <div className={styles.text}>
                                          <img
                                                className={styles.iconinfo}
                                                alt=""
                                                src="images/info.svg"
                                          />
                                          <div className={styles.div5}>
                                                <span>{`팝업/축제/공연/전시 등 `}</span>
                                                <span className={styles.span}>
                                                      진행 기간이 있는 핫플에만 설정
                                                </span>
                                          </div>
                                    </div>
                                    <div className={styles.text}>
                                          <img
                                                className={styles.iconinfo}
                                                alt=""
                                                src="images/info.svg"
                                          />
                                          <div className={styles.div5}>
                                                <span className={styles.span}>{`'댓글 이벤트'는 진행 기간이 아님! `}</span>
                                                <span>
                                                      혼동하지 않도록 유의
                                                </span>
                                          </div>
                                    </div>
                              </div>
                              <div className={styles.periodframe}>
                                    <div className={styles.div1}>기간 :</div>
                                    <div className={styles.periodinputframe}>                                          
                                          <DatePicker
                                                ref={datePickerRef1}
                                                className={styles.periodinput1}
                                                selected={startDate}
                                                onChange={(date)=>{setStartDate(date)}}
                                                showTimeSelect
                                                dateFormat="yyyy/MM/dd HH:mm"
                                                timeFormat="HH:mm"
                                                timeIntervals={30}
                                                locale={ko}
                                                placeholderText="시작일 없음"
                                                onFocus={e => e.target.blur()}
                                                renderCustomHeader={({
                                                date,
                                                decreaseMonth,
                                                increaseMonth,
                                                prevMonthButtonDisabled,
                                                nextMonthButtonDisabled,
                                                }) => (
                                                      <div>
                                                            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '5px' }}>
                                                            <div onClick={clearDate1} className={styles.noPeriodButton}>시작일은 따로 없어요!</div>
                                                      </div>
                                          
                                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                            <div className={styles.monthButton} onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                                                            {'<'}
                                                      </div>
                                                      <span className={styles.monthText}>
                                                            {format(date, 'yyyy년 MM월', { locale: ko })}
                                                      </span>
                                                            <div className={styles.monthButton} onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                                                            {'>'}
                                                            </div>
                                                      </div>
                                                    </div>
                                                )}
                                                withPortal
                                          />

                                          <div className={styles.div8}>~</div>

                                          <DatePicker
                                                ref={datePickerRef2}
                                                className={styles.periodinput1}
                                                selected={endDate}
                                                onChange={(date)=>{setEndDate(date)}}
                                                showTimeSelect
                                                dateFormat="yyyy/MM/dd HH:mm"
                                                timeFormat="HH:mm"
                                                timeIntervals={30}
                                                locale={ko}
                                                placeholderText="종료일 없음"
                                                onFocus={e => e.target.blur()}
                                                renderCustomHeader={({
                                                date,
                                                decreaseMonth,
                                                increaseMonth,
                                                prevMonthButtonDisabled,
                                                nextMonthButtonDisabled,
                                                }) => (
                                                      <div>
                                                            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '5px' }}>
                                                            <div onClick={clearDate2} className={styles.noPeriodButton}>종료일은 따로 없어요!</div>
                                                      </div>
                                          
                                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                            <div className={styles.monthButton} onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                                                            {'<'}
                                                      </div>
                                                      <span className={styles.monthText}>
                                                            {format(date, 'yyyy년 MM월', { locale: ko })}
                                                      </span>
                                                            <div className={styles.monthButton} onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                                                            {'>'}
                                                            </div>
                                                      </div>
                                                </div>
                                                )}
                                                withPortal
                                          />
                                    </div>
                              </div>
                        </div>
                  </div>
                  {originalHotple.need_verify?
                  <div
                        className={styles.nextButtonActive}
                        onClick={handleNextButtonClick}
                  >
                        <div className={styles.text1}>거의 다왔어요! (2/3)</div>
                  </div>
                  :
                  <div className={styles.editbuttonsframe}>
                        <div className={styles.cancelButton} onClick={()=>handleCancelButtonClick()}>
                              <div className={styles.cancellabel}>돌아가기</div>
                        </div>
                        <div
                              className={styles.editButton}
                              onClick={()=>handleEditButtonClick()}
                        >
                              <div className={styles.edittext}>수정하기</div>
                        </div>
                  </div>
                  }
            </div>
      </div>);
};

export default ReviewHotpleModal2;